import axios from "axios";

function getBaseUrl() {
    switch (process.env.REACT_APP_ENV) {
        case "PROD": {
            return window.location.origin;
        }
        // case "BETA": {
        //     return "http://139.99.90.93";
        // }
        case "DEV": {
            return process.env.REACT_APP_LIFELINE_BACKEND_URL || "http://localhost";
        }
        default: {
            return window.location.origin;
        }
    }
}

const baseURL = getBaseUrl();

export default axios.create({
    baseURL,
});